import React from 'react';
import { connect } from 'react-redux';
import { Dropdown } from 'semantic-ui-react';
import { checkVehicle } from '../../redux/actions/documentActions';

//importActions
import { selectVehicleId } from '../../redux/actions/formActions'

function VehicleDropDown({
    field: { name, value },
    form: { touched, errors, setFieldValue },
    vehicleData,
    loading,
    ...props
}) {

    const vehicleOptions = []
    if (vehicleData && vehicleData.length > 0) {
        vehicleData.map((object, index) => {
            let temp = {}
            temp.key = object.vehicleMasterId
            temp.text = object.vehicleNumber
            temp.value = object.vehicleMasterId
            return vehicleOptions[index] = temp
        })
    }

    const { selectVehicleId, checkVehicle } = props


    const handleChange = (e, data) => {
        data.options.forEach(element => {
            if (element.value == data.value) {
                if (props?.vehicleNoName) {
                    setFieldValue(props.vehicleNoName, element.text)
                }
            }
        });

        setFieldValue(name, data.value);
        selectVehicleId(data.value)
        checkVehicle(data.value);
    }

    return (
        <Dropdown
            selection
            placeholder="Vehicle No."
            search
            loading={loading}
            onChange={handleChange}
            options={vehicleOptions}
            {...props}
        />
    )
}


const mapStatetoProps = (state) => ({
    vehicleData: state.getVehicleNo.vehicleNo.resultSet,
    loading: state.getVehicleNo.isLoading
})

export default connect(mapStatetoProps, { selectVehicleId, checkVehicle })(VehicleDropDown)